import { useEffect, useState } from "react";
import WydarzeniaContainer from "../../components/elements/WydarzeniaContainer/WydarzeniaContainer";
import MiddleBlock from "../../components/MiddleBlock/MiddleBlock";
import SectionHeader from "../../components/SectionHeader/SectionHeader";
import "./Events.css"
import { getApiErrorMessage, getEvents } from "../../api/api";
import { NavLink } from "react-router-dom";
import Pagination from "../../components/elements/Pagination/Pagination";
import Loader from "../../components/elements/Loader/Loader";
import ApiNotice from "../../components/elements/ApiNotice/ApiNotice";
import { parseEventColors } from "../../utils/parseEventColors";
import EmptyState from "../../components/elements/EmptyState/EmptyState";

export default function Events() {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState('');
    const itemsPerPage = 5;

    useEffect(() => {
        async function loadEvents() {
            setLoading(true);
            setError('');
            try {
                const limit = itemsPerPage;
                const offset = (page - 1) * itemsPerPage;
                
                const result = await getEvents(limit, offset);
                
                if (result && result.data && Array.isArray(result.data)) {
                    setEvents(result.data);
                    setTotalPages(Math.ceil((result.total || 0) / itemsPerPage));
                } else if (Array.isArray(result)) {
                    setEvents(result);
                    setTotalPages(Math.ceil((result.length || 0) / itemsPerPage));
                } else {
                    setEvents([]);
                    setTotalPages(1);
                    console.warn('Nieznany format odpowiedzi:', result);
                }
            } catch (error) {
                console.error('Nie udało się wczytać wydarzeń:', error);
                setError(getApiErrorMessage(error, 'Nie udało się pobrać wydarzeń.'));
                setEvents([]);
                setTotalPages(1);
            } finally {
                setLoading(false);
            }
        }
        
        loadEvents();
    }, [page]);

    const handlePageChange = (newPage) => {
        setPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    if (loading) return <Loader />;

    return (
        <>
            <SectionHeader>
                Wydarzenia
                <p className="section-paragraph">
                    od najnowszych do minionych
                </p>
            </SectionHeader>
            <MiddleBlock>
                <div className="wydarzenia-container">
                    {localStorage.getItem("isAdmin") === 'true' ? 
                        <NavLink to={"/create-event"}>
                            <button className="button-add-event">Dodaj wydarzenie</button>
                        </NavLink>
                    : ("")}
                    
                    {error ? (
                        <ApiNotice type="error" title="Nie udało się wczytać wydarzeń">{error}</ApiNotice>
                    ) : events.length > 0 ? (
                        events.map(event => {
                            return (
                                <WydarzeniaContainer
                                    key={event.id}
                                    id={event.id}
                                    title={event.title}
                                    description={event.short_description}
                                    date={event.event_date}
                                    image={event.image}
                                    imagePosition={event.image_position}
                                    imagePositionMobile={event.image_position_mobile}
                                    hex={parseEventColors(event?.colors)}
                                />
                            )
                        })
                    ) : (
                        <EmptyState type="events" title="Brak wydarzeń">
                            Nowe wydarzenia pojawią się tutaj, gdy tylko zostaną opublikowane.
                        </EmptyState>
                    )}
                    
                    {totalPages > 1 && (
                        <Pagination 
                            currentPage={page}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                            showInfo={true}
                        />
                    )}
                </div>
            </MiddleBlock>
        </>
    );
}
